module.exports = __webpack_public_path__ + "static/c_-1-fa765c3312deef387a3b00f5f5cbbb8c.jpg";